import { render, staticRenderFns } from "./AnswerDropDown.vue?vue&type=template&id=45b835fe&"
import script from "./AnswerDropDown.vue?vue&type=script&lang=js&"
export * from "./AnswerDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports